import React from "react";
import styled from "styled-components";
import { useTranslation } from "gatsby-plugin-react-i18next";

import { down, spacings, fonts, colors } from "~/src/config/vars";
import { Container, ScrollAnim } from "~/src/components";

const BlockAboutSmall = () => {
    const { t } = useTranslation();

    return (
        <SBlockAboutSmall className="bg">
            <Container size="large">
                <ScrollAnim type="slideInDown" delay={0}>
                    {t("block_about_small_text")}
                </ScrollAnim>
            </Container>
        </SBlockAboutSmall>
    );
};

const SBlockAboutSmall = styled.div`
    padding: ${spacings?.offset_80} 0 ${spacings?.offset_80};
    font-size: ${fonts?.fs_30};
    background-color: ${colors?.beige_base};
    font-weight: ${fonts?.fw_bold};
    font-family: ${fonts?.ff_title};
    text-align: center;
    position: relative;
    ${down("sm")} {
        font-size: ${fonts?.fs_18};
    }
    &:after {
        background: #ebc7ac;
    }
    > div {
        position: relative;
        z-index: 2;
    }
`;

export default BlockAboutSmall;
